export default {
  language_selector: {
    label: 'Elige un idioma',
  },
  nav_items: {
    home: 'Inicio',
    menu: 'Menú',
    locations: 'Ubicaciones',
    store_info: 'Info del local',
    rewards: 'Recompensas',
  },
};
